import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import env from "../../../config/env";
import * as auth from "../../store/ducks/auth.duck";
import { useMsal } from "@azure/msal-react";
import { LayoutSplashScreen } from "../../../_metronic";
import { msGraphGetProfileImage } from "./MsGraph";
import { loginRequest } from "../../../config/authConfig";

// Apollo Client
import ApolloClient from "apollo-boost";
import { getCsrfToken } from '@utils/common';
import { gql } from "apollo-boost";

const client = new ApolloClient({
  uri: env.graphqluri,
  credentials: "include",
  request: (operation) => {
    operation.setContext({
      headers: {
        "X-CSRF-Token": getCsrfToken(),
      },
    });
  },
});

const UPDATE_USER_PHOTO = gql`
  mutation ($oid: String!, $photo: String, $msal_accessToken: String, $msal_accessTokenExpiresOn: String) {
    UpdateUserPhoto(oid: $oid, photo: $photo, msal_accessToken: $msal_accessToken, msal_accessTokenExpiresOn: $msal_accessTokenExpiresOn) {
      _id
    }
  }
`;

function GetJwtToken(props) {
  const { instance, accounts } = useMsal();
  const history = useHistory();
  const [tokenExtracted, setTokenExtracted] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        const extractMsalIdToken = () => {
          for (const key of Object.keys(sessionStorage)) {
            if (key.includes("idtoken")) {
              const val = JSON.parse(sessionStorage.getItem(key));
              if (val.secret) return val.secret;
            }
          }
          throw new Error("No valid token found");
        };

        const token = `Bearer ${extractMsalIdToken()}`;
        setTokenExtracted(token);
      } catch (error) {
        console.error("Token extraction failed:", error);
        setTimeout(() => window.location.reload(), 1000);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!tokenExtracted) return;

    const options = {
      method: "POST",
      headers: { Authorization: tokenExtracted },
      body: JSON.stringify({}),
    };

    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        setTimeout(() => {
          const oid = response.account.idTokenClaims.oid;

          msGraphGetProfileImage(response.accessToken)
            .then((image) => {
              fetch(env.login_openid_url, options)
                .then((res) => res.json())
                .then(() => {
                  props.login();

                  setTimeout(() => {
                    client
                      .mutate({
                        mutation: UPDATE_USER_PHOTO,
                        variables: {
                          oid: oid,
                          photo: image,
                          msal_accessToken: response.accessToken,
                          msal_accessTokenExpiresOn: response.expiresOn,
                        },
                      })
                      .then(
                        () => {
                          console.log("User profile picture successfully updated.");
                          history.push("/");
                        },
                        (err) => {
                          console.log(`Login update photo error: ${err}`);
                          history.push("/");
                        }
                      );
                  }, 1000);
                })
                .catch((e) => {
                  console.log(`Login error: ${e}`);
                  setTimeout(() => history.push("/"), 1000);
                });
            })
            .catch((e) => {
              fetch(env.login_openid_url, options)
                .then((res) => res.json())
                .then(() => {
                  props.login();
                  setTimeout(() => history.push("/"), 1000);
                })
                .catch((e) => {
                  console.log(`Login fetch error: ${e}`);
                  setTimeout(() => history.push("/"), 1000);
                });
              console.log(`Login get photo error: ${e}`);
            });
        }, 500);
      })
      .catch((e) => {
        console.log(`Login acquire token silent error: ${e}`);
      });
  }, [tokenExtracted]); // ✅ Execute this effect only when token is available

  return <LayoutSplashScreen />;
}

function Success(props) {
  return <GetJwtToken login={props.login} />;
}

export default injectIntl(
  connect(null, { login: auth.actions.login })(Success)
);
